<style lang="less" scoped>
/*@import "../../style/common.less";*/
@import "../../style/color.less";
@import "../../style/button.css";
/*@import "../../style/greenStyle.less";*/
/*@import "../../style/custom.less";*/
/*@import "../../style/components.less";*/
/*@import "../../style/uniform.default.min.less";*/

.flex-1 {
	flex: 1;
}

.flex-2 {
	flex: 2;
}

.date1 {
	width: 150px;
	height: 38px;
}

.fcc_bgpg {
	/*background: url("../../img/footer_logo_fcc.svg")no-repeat;*/
	/*z-index:1;*/
	/*background-position: 95%;*/
}

.formTable {
	float: left;
	margin-top: 10px;
	width: 80%;
	//width: 1300px;
	height: 150px;
	margin-bottom: 10px;
	/*border: 1px red solid;*/
	/*background: url("../../img/fccLOGO.png")no-repeat;*/
	/*background-position: 85%;*/
	/*border: 1px red solid;*/
}

.logoPG {
	width: 20%;
	height: 150px;
	float: right;
	margin-top: 10px;
	margin-bottom: 10px;
	/*border: 1px red solid;*/
	/*position: relative;*/
	/*right: 100px;*/
	/*bottom: 100px;*/
}

.like_instNo {
	float: left;
	width: 290px;
	height: 50px;
}

.like_date {
	float: left;
	width: 650px;
	height: 50px;
}

.firstRow {
	/*float: left;*/
	height: 50px;
	/*width: 80%;*/
	/*margin-bottom: 20px;*/
	/*width: 1000px;*/
}

.secondRow {
	float: left;
	height: 50px;
	/*width: 80%;*/
	/*border: 1px black solid;*/
	margin-top: 10px;
	margin-bottom: 10px;
	/*width: 1000px;*/
}

.like_date {
	float: left;
	width: 450px;
	height: 50px;
}

.like_cust {
	float: left;
	width: 450px;
	height: 50px;
}

.min-320 {
	min-width: 320px;
}

.min-540 {
	min-width: 540px;
}

.min-520 {
	min-width: 500px;
}

.min-680 {
	min-width: 680px;
}

.min-220 {
	min-width: 220px;
}

.inline-block {
	display: inline-block;
}

.query-div-select {
	width: 150px;
}

.label-control {
	display: inline-block;
	font-size: 14px;
	font-weight: 700;
	color: yellowgreen;
}

/*.el-table {
	background: linear-gradient(to right, #092a9c, #0c5692) !important ;
}*/
.form-control {
	background-color: white !important;
}

span.query-title-span {
	display: inline-block;
	width: 90px;
	font-size: 14px;
	font-weight: 700;
	text-align: right;
	margin-right: 20px;
	color: black;
}

span.queryMust-title-span {
	display: inline-block;
	width: 90px;
	font-size: 14px;
	font-weight: 700;
	text-align: right;
	margin-right: 20px;
	color: red;
}

span.query-title-line {
	display: inline-block;
	font-size: 14px;
	font-weight: 700;
	text-align: center;
	width: 30px;
	color: yellowgreen;
}

/*.portlet.light{*/
/*	background: linear-gradient(to right, #092a9c, #0c5692) !important ;*/
/*}*/
.query-div-input-date {
	width: 150px;
}

.query-div {
	// border: 1px solid #ddd;
	padding: 16px 0;
	border-radius: 4px;
}

.margin-left-8 {
	margin-left: 8px;
}

.draw-enter-active, .draw-leave-active {
	transition: all 1s ease;
}

.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
	height: 0;
	overflow: hidden;
}

.uploadImg {
	width: 100%;
	height: 1.5rem;
	position: relative;

	input {
		width: 1.46rem;
		height: 100%;
		z-index: 1;
		opacity: 0;
		position: absolute;
		cursor: pointer;
	}
}

span.limitNum {
	display: inline-block;
	width: 280px;
	font-size: 17px;
	font-weight: 700;
	text-align: center;
	/*margin-left: 20px;*/
	color: black;
}
</style>
<style lang="less">
.dialog-input-text .el-input__inner {
	//width: 75px;
	width: 100%;
	height: 40px;
	border: 1px solid deepskyblue;
	font-weight: bold;
}

//数字靠右
.dialog-input-text2 .el-input__inner {
	//width: 75px;
	width: 100%;
	height: 40px;
	border: 1px solid deepskyblue;
	text-align: right;
}

.el-date-table {
	font-size: 18px;
}

.el-date-table tr td:first-child {
	color: #CE4040;
}

.el-date-table tr td:last-child {
	color: #8DEF56;
}

span.query-title-span1 {
	display: inline-block;
	width: 110px;
	font-size: 14px;
	font-weight: 700;
	text-align: right;
	margin-right: 20px;
	color: black;
}
</style>
<template>
	<div class="iot-vue-container">
		<!-- 标题组件 -->
		<!--		<div class="vue-header">-->
		<!--			<div class="vue-header-title-div">-->
		<!--				<span class="vue-header-title" @click="init()">&nbsp;&nbsp;{{ pageTitle }}</span>-->
		<!--			</div>-->
		<!--			<div class="vue-header-breadcrumb">-->
		<!--				&lt;!&ndash;<Breadcrumb>-->
		<!--					<BreadcrumbItem :to="{name:sysCfg.mainPage}">首页</BreadcrumbItem>-->
		<!--					<BreadcrumbItem>{{sysCfg.modules.null}}</BreadcrumbItem>-->
		<!--					<BreadcrumbItem :to="{name:sysCfg.tRealtimeFillin.name_en}">{{sysCfg.tRealtimeFillin.name}}</BreadcrumbItem>-->
		<!--			   </Breadcrumb>&ndash;&gt;-->
		<!--			</div>-->
		<!--		</div>-->
		<div class="vue-main">
			<div class="fcc_bgpg">
				<!--查询条件 -->
				<div class="formTable">
					<div class="firstRow">
						<div class="like_instNo">
							<span class="query-title-span">报价期限</span>
							<el-date-picker value-format="yyyy-MM-dd" class="query-div-select inline-block"
											v-model="queryParam.otnTerm" :editable="false" placeholder="选择月份">
							</el-date-picker>
						</div>
						<div class="like_instNo">
							<span class="query-title-span">询价单号</span>
							<el-input type="text" style="width: 150px" v-model="queryParam.kbRqstNo"/>
						</div>
						<div class="like_instNo">
							<span class="query-title-span">询价明细号</span>
							<el-input type="text" style="width: 150px" v-model="queryParam.kbRqstDNo"/>
						</div>
						<div class="like_instNo">
							<span class="query-title-span">部品编号</span>
							<el-input type="text" style="width: 150px" v-model="queryParam.itmCode"/>
						</div>

					</div>
					<div class="firstRow">
						<div class="like_instNo">
							<span class="query-title-span">部品名称</span>
							<el-input type="text" style="width: 150px" v-model="queryParam.itmName"/>
						</div>
						<div class="like_instNo" v-if="insideFlg">
							<span class="query-title-span">供应商代码</span>
							<el-input v-if="disableFlg" type="text" style="width: 150px" v-model="queryParam.spplCd"
									  disabled/>
							<el-input v-else type="text" style="width: 150px" v-model="queryParam.spplCd"/>
						</div>

						<div class="like_instNo" v-if="insideFlg">
							<span class="query-title-span">供应商名称</span>
							<el-input v-if="disableFlg" type="text" style="width: 150px" v-model="queryParam.spplNm"
									  disabled/>
							<el-input v-else type="text" style="width: 150px" v-model="queryParam.spplNm"/>
						</div>
<!--						<div class="like_instNo" v-if="insideFlg">-->
<!--							<span class="query-title-span">评价担当</span>-->
<!--							<el-input type="text" style="width: 150px" v-model="queryParam.usrCd"/>-->
<!--						</div>-->
						<div class="like_date">
							<span class="query-title-span">发行日期</span>
							<el-date-picker value-format="yyyy-MM-dd" class="query-div-select inline-block"
											v-model="queryParam.issueDtFrom" :editable="false" placeholder="选择日期">
							</el-date-picker>
							-
							<el-date-picker value-format="yyyy-MM-dd" class="query-div-select inline-block"
											v-model="queryParam.issueDtTo" :editable="false" placeholder="选择日期">
							</el-date-picker>
						</div>
					</div>

					<!--				<div class="firstRow">-->
				</div>
				<div class="logoPG">
					<!--<div class="logoPG">-->
					<img src="../../img/footer_logo_fcc.svg" width="140px" height="150px" style="margin-left: 10px"/>
					<!--</div>-->
				</div>
				<!--操作功能区 -->
				<div class="secondRow">
					<div class="actions-div  margin-bottom-10">
						<el-dialog
							title="密令验证"
							:close-on-click-modal="false"
							:visible.sync="dialogVisibleKey"
							width="30%">
							<div>
							<span style="font-size: large;color: inherit;font-weight: bolder">查看理由</span>
							<el-input
								type="textarea"
								:rows="4"
								placeholder="请输入理由"
								v-model="keyInfo.reason">
							</el-input>
							</div>
							<div style="margin-top: 20px;margin-bottom: 10px">
							<span style="font-size: large;color: inherit;font-weight: bolder">密令</span>
							<el-input
								placeholder="请输入密令"
								class="dialog-input-text"
								v-model="keyInfo.sKey">
							</el-input>
							</div>
							<span slot="footer">
									<el-button type="primary" style="float: left" @click="getSKey">获取密令</el-button>
									<el-button type="success" @click="verifySKey">查 看</el-button>
							</span>
						</el-dialog>
						<div class="pull-right margin-top-10">
							<!--搜索区 -->
							<Button type="primary" class="button button-glow button-rounded button-royal"
									v-loading.fullscreen.lock="fullscreenLoading" icon="ios-search" slot="append"
									@click="getList('query')">检索
							</Button>
<!--							<Button type="primary" class="button button-glow button-rounded button-action"-->
<!--									   @click="mailSend"><i class="fa fa-check"></i>发密令-->
<!--							</Button>-->
						</div>
					</div>
				</div>
				<!--操作功能区 -->
			</div>
			<!--表格区-->
			<el-table :data="listData" ref="multipleTable" :row-style="rowStyle" @selection-change="handleSelectionChange"
					  :cell-style="tableRowStyle" :header-cell-style="tableHeaderColor" border row-key="id"
					  :height="600">
<!--				<el-table-column type="selection" align="center" width="40" fixed></el-table-column>-->
				<el-table-column label="报价详细" min-width="120" align="center" v-if="insideFlg" >
					<template slot-scope="scope">
						<Button v-if="scope.row.inqConfirmStatus=='2'" class="button button-glow button-rounded button-highlight"
								@click="openQtn(scope.row)"><i class="fa fa-reply fa-fw"></i> 查看
						</Button>
						<Button v-if="scope.row.inqConfirmStatus=='4'" class="button button-glow button-rounded button-highlight"
								@click="openQtn2(scope.row)"><i class="fa fa-reply fa-fw"></i> 查看
						</Button>
						<Button v-if="scope.row.inqConfirmStatus=='0' || scope.row.inqConfirmStatus=='1' || scope.row.inqConfirmStatus=='3'" class="button  button-rounded "
								disabled="disabled"><i class="fa fa-download fa-fw" ></i> 查看
						</Button>
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="120" align="center" v-if="!insideFlg" >
					<template slot-scope="scope">
						<Button class="button button-glow button-rounded button-highlight"
								@click="openQtn2(scope.row)"><i class="fa fa-reply fa-fw"></i> 回复
						</Button>
					</template>
				</el-table-column>
				<el-table-column prop="kbRqstType" label="询价种类" :formatter="getRqstType" align="left" min-width="100" >
				</el-table-column>
				<el-table-column prop="kbRqstNo" label="询价单号" align="left" min-width="160" >
				</el-table-column>
				<el-table-column prop="kbRqstDNo" label="询价明细号" align="left" min-width="160" >
				</el-table-column>
				<el-table-column prop="issueDt" value-format="yyyy-MM-dd" label="发行日期" align="left" min-width="140" >
				</el-table-column>
				<el-table-column prop="otnTerm" label="报价期限" align="left" min-width="140" >
				</el-table-column>
				<el-table-column prop="bidStatus" label="中标状态" align="left" min-width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.bidStatus=='1'" style="color: red;font-weight: bolder;font-size: 16px">未中标</span>
						<span v-if="scope.row.bidStatus=='2'" style="color: limegreen;font-weight: bolder;font-size: 16px">已中标</span>
						<span v-if="scope.row.bidStatus=='0'">未开标</span>
					</template>
				</el-table-column>
				<el-table-column prop="spplCd" label="供应商代码" align="left" v-if="insideFlg" min-width="120">
				</el-table-column>
				<el-table-column prop="spplNm" label="供应商" align="left" v-if="insideFlg" min-width="200">
				</el-table-column>
				<el-table-column prop="itmCode" label="部品编号" align="center" min-width="150">
				</el-table-column>
				<el-table-column prop="itmName" label="部品名称" align="center" min-width="100">
				</el-table-column>
				<el-table-column prop="inqConfirmStatus" label="确认状态" :formatter="getConfirmStatus" align="center" min-width="100" >
				</el-table-column>
				<el-table-column prop="readDt" label="查看时间" align="center" min-width="180">
				</el-table-column>
				<el-table-column prop="qtnNo" label="报价单号" align="left" min-width="180" >
				</el-table-column>
				<el-table-column prop="qtnDt" label="报价时间" align="center" min-width="180">
				</el-table-column>
				<el-table-column prop="refuseReason" label="拒绝理由" align="center" min-width="120">
				</el-table-column>
				<el-table-column prop="extItmNm" label="型号" align="center" v-if="!insideFlg" min-width="60">
				</el-table-column>
				<el-table-column prop="qty" label="数量" align="center" v-if="!insideFlg" min-width="60">
				</el-table-column>
				<el-table-column prop="unitCd" label="单位" align="center" v-if="!insideFlg" min-width="60">
				</el-table-column>
				<el-table-column prop="designChange" label="设变" align="center" v-if="!insideFlg" min-width="60">
				</el-table-column>
				<el-table-column prop="remark" label="备注" align="center" v-if="!insideFlg" min-width="100">
				</el-table-column>
				<el-table-column label="询价单" min-width="120" align="center">
					<template slot-scope="scope">
						<Button class="button button-glow button-rounded button-primary"
								@click="beforeRqstDw(scope.row.id)"><i class="fa fa-download fa-fw"></i> 下载
						</Button>
					</template>
				</el-table-column>
<!--				<el-table-column prop="kbRqstInfoFilename" label="文件名" align="center" min-width="100">-->
<!--				</el-table-column>-->
				<el-table-column label="询价资料" min-width="120" align="center">
					<template slot-scope="scope">
						<Button v-if="scope.row.kbRqstInfoFilename=='null' || scope.row.kbRqstInfoFilename == null || scope.row.kbRqstInfoFilename == ''" class="button  button-rounded "
								disabled="disabled"><i class="fa fa-download fa-fw" ></i> 下载
						</Button>
						<Button v-else class="button button-glow button-rounded button-primary"
								@click="beforeRqstInfoDw(scope.row.id)"><i class="fa fa-download fa-fw"></i> 下载
						</Button>
					</template>
				</el-table-column>
				<el-table-column label="报价单" min-width="120" align="center">
					<template slot-scope="scope">
						<Button v-if="scope.row.qtnUploadStatus=='1'"
								class="button button-glow button-rounded button-primary"
								@click="beforeQtnDw(scope.row.id)"><i class="fa fa-download fa-fw"></i> 下载
						</Button>
						<Button v-else class="button  button-rounded "
								disabled="disabled"><i class="fa fa-download fa-fw" ></i> 下载
						</Button>
					</template>
				</el-table-column>
				<el-table-column label="报价附件" min-width="120" align="center">
					<template slot-scope="scope">
						<Button v-if="scope.row.qtnInfoUploadStatus=='1'"
								class="button button-glow button-rounded button-primary"
								@click="beforeQtnInfoDw(scope.row.id)"><i class="fa fa-download fa-fw"></i> 下载
						</Button>
						<Button v-else class="button  button-rounded "
								disabled="disabled"><i class="fa fa-download fa-fw" ></i> 下载
						</Button>
					</template>
				</el-table-column>
			</el-table>

			<!--表格区-->
			<!--分页区 -->
			<el-pagination class="iot-pagination" :current-page="pageParams.currentPage"
						   :page-sizes="sysCfg.pageParams.opts" @size-change="handleSizeChange"
						   @current-change="handlePageChange" :page-size="pageParams.pageSize"
						   :layout="sysCfg.pageParams.pageLayout" :total="pageParams.total">
			</el-pagination>
		</div>
	</div>
</template>
<script>
import config from '@/config/config.js';
import moment from 'moment';
import {mapActions} from "vuex";
import httpUtil from "../../utils/httpUtil";
import api from "../../config/apiConfig";
import axios from 'axios';
import Da from "element-ui/src/locale/lang/da";
import tabCtrl from "../../components/TabCtrl";

export default {
	data() {
		return {
			pageTitle: '采购信息一览',
			sysCfg: config,
			listData: [],
			pageParams: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			queryParam: {
				otnTerm: '',
				issueDtFrom: '',
				issueDtTo: '',
				spplCd: '',
				spplNm: '',
				kbRqstNo:'',
				kbRqstDNo: '',
				itmCode: '',
				itmName: '',
				pageNum: 0,
				pageSize: 10
			},
			keyInfo:{
				sKey:'',
				reason:'',
				kbRqstNo:'',
				kbRqstDNo:'',
				spplCd:'',
			},
			searchVal: '',
			fullscreenLoading: false,
			dialogVisibleKey: false,
			multipleSelection: [],
			disableFlg: false,
			insideFlg: false,
			uploadEvaNo: '',
			qtnRouter:'tQuotation',
		};
	},
	methods: {
		...mapActions("tab", ["reflush"]),
		init() {
			var _this = this;
			// 数据初始化
			_this.searchVal = '';
			_this.uploadEvaNo = '';
			_this.queryParam.issueDtFrom = this.getThisMonth();
			_this.queryParam.issueDtTo = this.getToDay();
			var currUser = JSON.parse(_this.$cookie.get(_this.$config.cookies.currUser));
			if (currUser.userType == '1') {//自公司用户
				_this.insideFlg = true;
			} else if (currUser.userType == '2') {//供应商用户
				_this.queryParam.spplCd = currUser.spplCd;
				// _this.queryParam.spplNm=currUser.spplName;
				_this.insideFlg = false;
				_this.disableFlg = true;
			}
		},
		// 获取默认时间
		getThisMonth() {
			var yearUnix = new Date().getFullYear();
			var monthUnix = new Date().getMonth();
			var now = new Date().setFullYear(yearUnix, monthUnix, 1);
			return this.$util.toDate(now);
		},

		mailSend(){
			let _this = this;
			// let param = {
			//
			// };
			// _this.$httpUtil.ajaxPost(this, _this.$api.tInquiry.mailSend, param, function (res) {
			// 	if (res.data.data.status == 200) {
			// 		_this.$util.success(res.data.data.message);
			// 	} else {
			// 		_this.$util.error2(res.data.data.message);
			// 	}
			// });
			this.dialogVisibleKey = true;
		},

		//获取密令
		getSKey(){
			let _this = this;
			if (_this.keyInfo.reason =='' || _this.keyInfo.reason ==undefined || _this.keyInfo.reason ==null){
				_this.$util.error("请先输入查看理由");
				return;
			}
			_this.$httpUtil.ajaxPost(this, _this.$api.tInquiry.getSKey, _this.keyInfo, function (res) {
				if (res.data.data.status == 200) {
					_this.$util.success2(res.data.data.message);
				} else {
					_this.$util.error2(res.data.data.message);
				}
			});
		},

		//验证密令
		verifySKey(){
			let _this = this;
			if (_this.keyInfo.reason =='' || _this.keyInfo.reason ==undefined || _this.keyInfo.reason ==null){
				_this.$util.error("请输入查看理由");
				return
			}
			if (_this.keyInfo.sKey =='' || _this.keyInfo.sKey ==undefined || _this.keyInfo.sKey ==null){
				_this.$util.error("请输入密令");
				return;
			}

			_this.$httpUtil.ajaxPost(this, _this.$api.tInquiry.verifySKey, _this.keyInfo, function (res) {
				if (res.data.data.status == 200) {
					//关闭弹窗
					_this.dialogVisibleKey = false;
					let resultEntity = res.data.data.data;
					//跳转画面
					const item = tabCtrl.state.Tabs.find(t => t.routername == _this.qtnRouter);
					if (item){
						tabCtrl.mutations.DelCache(tabCtrl.state,_this.qtnRouter);
					}
					_this.$router.push({
						name: _this.qtnRouter,
						query: {
							kbRqstDNo: resultEntity.kbRqstDNo,
							spplCd: resultEntity.spplCd,
							qtnType: resultEntity.kbRqstType,
						}
					});
				} else {
					_this.$util.error2(res.data.data.message);
				}
			});
		},

		getToDay() {
			// var yearUnix = new Date().getFullYear();
			// var monthUnix = new Date().getMonth();
			// var now = new Date().setFullYear(yearUnix, monthUnix, 1);
			// return this.$util.toDate(now);
			return this.$util.toDate(new Date());
		},
		// 获取列表
		getList(val) {
			let idf = this.queryParam.issueDtFrom;
			let idt = this.queryParam.issueDtTo;
			if (idf > idt) {
				this.$util.error("发行日期（结束）不可小于发行日期（开始）");
				return;
			}
			if (val !== undefined) {
				this.pageParams.currentPage = 1;
			}
			var _this = this;
			_this.initQueryParam();
			this.fullscreenLoading = true;
			// console.log(_this.queryParam,"====2====query==");
			_this.$httpUtil.ajaxGet(this, _this.$api.tInquiry.getList, _this.queryParam, function (response) {
				_this.listData = response.data.data.content;

				if (_this.listData.length === 0 && _this.pageParams.currentPage > 1) {
					_this.pageParams.currentPage--;
					_this.getList();
				} else {
					_this.pageParams.total = response.data.data.totalElements;
					_this.fullscreenLoading = false;
				}
				//重新渲染table布局，解决fixed错位
				_this.$nextTick(() => {
					_this.$refs.multipleTable.doLayout();
				});
			});
		},

		// 初始化查询参数
		initQueryParam() {
			this.queryParam.pageNum = this.pageParams.currentPage - 1 >= 0 ? this.pageParams.currentPage - 1 : 0;
			this.queryParam.pageSize = this.pageParams.pageSize;
			// this.queryParam.startDate = this.startDate;
			// this.queryParam.endDate = this.endDate;
		},


		getRqstType(row, column, cellValue, index) {
			let typeName = '';
			if ('1' == cellValue) {
				typeName = "构成件";
			}
			if ('2' == cellValue) {
				typeName = "消耗品";
			}
			return typeName;
		},

		getConfirmStatus(row, column, cellValue, index) {
			let typeName = '';
			if ('0' == cellValue) {
				typeName = "未查看";
			}
			if ('1' == cellValue) {
				typeName = "已查看";
			}
			if ('2' == cellValue) {
				typeName = "已报价";
			}
			if ('3' == cellValue) {
				typeName = "拒绝";
			}
			if ('4' == cellValue) {
				typeName = "已完结";
			}
			return typeName;
		},

		//询价单下载前校验
		beforeRqstDw(id) {
			let _this = this;
			let param = {
				id: id,
			}
			_this.$httpUtil.ajaxGet(this, _this.$api.tInquiry.beforeRqstDw, param, function (response) {
				if (response.data.data.status == 200) {
					var fileName = response.data.data.data;
					_this.toRqstFileExport(id,fileName);
				} else {
					_this.$util.error2(response.data.data.message);
				}
			});
		},

		//文件下载
		toRqstFileExport(id,fileName) {
			let _this = this;
			let url = this.$api.tInquiry.toRqstExport;
			let param = {
				id: id,
			};
			const loading = this.$loading({
				lock: true,
				text: '正在加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			axios({
				method: 'get',
				url: url,
				params: param,
				headers: {
					'Content-Type': 'application/json;charset=UTF-8',
					'authorization': _this.$cookie.get('slash_token')
				},
				timeout: 60000,
				data: {},
				responseType: 'blob',
			}).then(response => {
				loading.close();
				_this.fileDownload(response.data,fileName);
			}).catch((error) => {
				loading.close();
				_this.fullscreenLoading = false;
			})
		},

		//询价资料下载前校验
		beforeRqstInfoDw(id) {
			let _this = this;
			let param = {
				id: id,
			}
			_this.$httpUtil.ajaxGet(this, _this.$api.tInquiry.beforeRqstInfoDw, param, function (response) {
				if (response.data.data.status == 200) {
					var fileName = response.data.data.data;
					_this.toRqstInfoFileExport(id,fileName);
				} else {
					_this.$util.error2(response.data.data.message);
				}
			});
		},

		//文件下载
		toRqstInfoFileExport(id,fileName) {
			let _this = this;
			let url = this.$api.tInquiry.toRqstInfoExport;
			let param = {
				id: id,
			};
			const loading = this.$loading({
				lock: true,
				text: '正在加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			axios({
				method: 'get',
				url: url,
				params: param,
				headers: {
					'Content-Type': 'application/json;charset=UTF-8',
					'authorization': _this.$cookie.get('slash_token')
				},
				timeout: 60000,
				data: {},
				responseType: 'blob',
			}).then(response => {
				loading.close();
				_this.fileDownload(response.data,fileName);
			}).catch((error) => {
				loading.close();
				_this.fullscreenLoading = false;
			})
		},

		//报价单下载前校验
		beforeQtnDw(id) {
			let _this = this;
			let param = {
				id: id,
			}
			_this.$httpUtil.ajaxGet(this, _this.$api.tInquiry.beforeQtnDw, param, function (response) {
				if (response.data.data.status == 200) {
					var fileName = response.data.data.data;
					_this.toQtnFileExport(id,fileName);
				} else {
					_this.$util.error2(response.data.data.message);
				}
			});
		},

		//文件下载
		toQtnFileExport(id,fileName) {
			let _this = this;
			let url = this.$api.tInquiry.toQtnExport;
			let param = {
				id: id,
			};
			const loading = this.$loading({
				lock: true,
				text: '正在加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			axios({
				method: 'get',
				url: url,
				params: param,
				headers: {
					'Content-Type': 'application/json;charset=UTF-8',
					'authorization': _this.$cookie.get('slash_token')
				},
				timeout: 60000,
				data: {},
				responseType: 'blob',
			}).then(response => {
				loading.close();
				_this.fileDownload(response.data,fileName);
			}).catch((error) => {
				loading.close();
				_this.fullscreenLoading = false;
			})
		},

		//报价单附件下载前校验
		beforeQtnInfoDw(id) {
			let _this = this;
			let param = {
				id: id,
			}
			_this.$httpUtil.ajaxGet(this, _this.$api.tInquiry.beforeQtnInfoDw, param, function (response) {
				if (response.data.data.status == 200) {
					var fileName = response.data.data.data;
					_this.toQtnInfoFileExport(id,fileName);
				} else {
					_this.$util.error2(response.data.data.message);
				}
			});
		},

		//文件下载
		toQtnInfoFileExport(id,fileName) {
			let _this = this;
			let url = this.$api.tInquiry.toQtnInfoExport;
			let param = {
				id: id,
			};
			const loading = this.$loading({
				lock: true,
				text: '正在加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			axios({
				method: 'get',
				url: url,
				params: param,
				headers: {
					'Content-Type': 'application/json;charset=UTF-8',
					'authorization': _this.$cookie.get('slash_token')
				},
				timeout: 60000,
				data: {},
				responseType: 'blob',
			}).then(response => {
				loading.close();
				_this.fileDownload(response.data,fileName);
			}).catch((error) => {
				loading.close();
				_this.fullscreenLoading = false;
			})
		},

		//下载文件
		fileDownload(data,fileName) {
			if (!data) {
				this.fullscreenLoading = false;
				return;
			}
			let url = window.URL.createObjectURL(new Blob([data], {
				type: 'application/octet-stream'
			}));
			let link = document.createElement('a');
			link.style.display = 'none';
			link.href = url;
			// var date = this.$util.getNow("yyyyMMddHHmmss");
			link.setAttribute('download',fileName);
			document.body.appendChild(link);
			link.click();
			this.fullscreenLoading = false;
		},

		openQtn(row) {
			var _this = this;
			_this.keyInfo.sKey = "";
			_this.keyInfo.reasons = "";
			_this.keyInfo.kbRqstNo = row.kbRqstNo;
			_this.keyInfo.kbRqstDNo = row.kbRqstDNo;
			_this.keyInfo.spplCd = row.spplCd;
			let param = {
				kbRqstNo:row.kbRqstNo
			};
			_this.$httpUtil.ajaxPost(this, _this.$api.tInquiry.beforeLinkCheck, param, function (res) {
				if (res.data.data.status == 200) {//申请过密令且验证通过
					const item = tabCtrl.state.Tabs.find(t => t.routername == _this.qtnRouter);
					if (item){
						tabCtrl.mutations.DelCache(tabCtrl.state,_this.qtnRouter);
					}
					_this.$router.push({
						name: _this.qtnRouter,
						query: {
							kbRqstDNo: row.kbRqstDNo,
							spplCd: row.spplCd,
							qtnType: row.kbRqstType,
						}
					});
				} else {
					_this.dialogVisibleKey = true;
				}
			});

		},

		//跳转，不做校验随便跳
		openQtn2(row) {
			var _this = this;
			const item = tabCtrl.state.Tabs.find(t => t.routername == _this.qtnRouter);
			if (item){
				tabCtrl.mutations.DelCache(tabCtrl.state,_this.qtnRouter);
			}
			_this.$router.push({
				name: _this.qtnRouter,
				query: {
					kbRqstDNo: row.kbRqstDNo,
					spplCd: row.spplCd,
					qtnType: row.kbRqstType,
				}
			});
		},


		handlePageChange(val) {
			this.pageParams.currentPage = val;
			this.getList();
		},
		handleSizeChange(val) { // 条数变更回调
			this.pageParams.pageSize = val;
			this.getList();
		},


		//设置表格行的样式
		tableRowStyle({row, column, rowIndex, columnIndex}) {
			return "border: 1px solid black !important;color:black;font-size:16px;padding: 7px 0;"
		},
		//设置表头行的样式
		tableHeaderColor({row, column, rowIndex, columnIndex}) {
			return 'border: 1px solid black !important; font-wight:500;font-size:15px;text-align:center;background-color: #CCCCCC !important;color:black;padding: 7px 0;'
		},
		//保存选中结果
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		rowStyle({row, rowIndex}) {
			let arr = this.multipleSelection;
			if (arr != null && arr.length > 0) {
				for (let i = 0; i < arr.length; i++) {
					if (row.id == arr[i].id) {
						return {"background-color": "rgba(0, 250, 154, 0.75)"};
					}
				}
			}
		},
	},
	mounted() {
		this.init();

	},
	watch: {}
};
</script>





// WEBPACK FOOTER //
// src/views/tInquiry/List.vue